/* eslint-disable */
import _ from 'underscore';
import $ from 'jquery';
import backbone from 'backbone';
import PageContext from '@bingads-webui-static-legacy/page-context';
import memSto from '@bingads-webui-component-legacy/storage/memoryStorage';
import odata from '@bingads-webui-static-legacy/communication/channel/odata';
import base from '@bingads-webui-static-legacy/wunderbar/data/collections/base';
import model from '@bingads-webui-static-legacy/wunderbar/data/models/adgroup';
import adgroupStatus from '@bingads-webui-static-legacy/schema/adgroup/entityStatus';
import * as odataQuery from '@bingads-webui/filter-entity';
import config from '@bingads-webui-component-legacy/config/index';
var keys = [];
var collection = base.extend({
  model: model.backbone,
  url: 'Advertiser/Customers()/Accounts()/',
  initialize: function () {
    this._meta = {};
    this.set('adgroupOptions', {});
    var adgroupChangedEvent = 'adGroupDeleted adGroupUpdated adGroupCreated';
    var adgroupChangeCallback = function (res, options) {
      var changed = res && _.isArray(res.data) ? res.data : options && _.isArray(options.models) ? options.models : [];
      _.each(changed, function (adGroup) {
        if (!adGroup.CampaignId) {
          _.each(keys, function (key) {
            memSto.invalidate(key);
          });
          keys = [];
        } else {
          var campaignId = adGroup.CampaignId.toString();
          _.each(keys, function (key, i) {
            if (key.indexOf(campaignId) > -1) {
              memSto.invalidate(key);
              keys.splice(i, 1);
            }
          });
        }
      });
    };
    window.App.off(adgroupChangedEvent, adgroupChangeCallback).on(adgroupChangedEvent, adgroupChangeCallback);
  },
  set: function (prop, value) {
    this._meta[prop] = value;
  },
  get: function (prop) {
    return this._meta[prop];
  },
  sync: function (method, model, options) {
    var self = this, adgroupOptions = self.get('adgroupOptions'), canCache = adgroupOptions.allowCaching === true && self._eligibleForCaching(adgroupOptions), adgroups, adgPro;
    if (method === 'read') {
      if (canCache) {
        adgPro = $.Deferred();
        adgroups = self._getFromCache(adgroupOptions);
        if (adgroups) {
          adgPro.resolve(adgroups);
          return adgPro.promise();
        }
      }
      var url = self._augmentUrl(self.url, options);
      adgPro = odata.get(url, null, options);
      if (canCache) {
        adgPro.done(function (data) {
          self._setCache(adgroupOptions, data);
        });
      }
      return adgPro;
    }
  },
  _eligibleForCaching: function (options) {
    return !(_.isUndefined(options.campaignId) || _.isUndefined(options.skip)) && !options.nameFilterText;
  },
  _setCache: function (options, data) {
    var newKey = this._getCacheKey(options), firstKey;
    if (keys.length === (options.maxCacheSize || 10)) {
      firstKey = keys[0];
      memSto.invalidate(firstKey);
      keys.shift();
    }
    memSto.set(newKey, data);
    keys.push(newKey);
  },
  _getFromCache: function (options) {
    return memSto.get(this._getCacheKey(options));
  },
  _getCacheKey: function (options) {
    return options.campaignId + '_' + options.skip;
  },
  _augmentUrl: function (url, options) {
    var urlEntity = 'AdGroups', resultUrl = url, adgroupOptions = this.get('adgroupOptions'), currentScope = adgroupOptions.scope ? adgroupOptions.scope.currentScope : null, campaignId = adgroupOptions.campaignId, filterText = adgroupOptions.nameFilterText ? adgroupOptions.nameFilterText : '', filterOptions = adgroupOptions.predicate, filterExpression = '';
    if (_.isArray(filterOptions)) {
      _.each(filterOptions, function (opt, idx) {
        if (idx !== 0) filterExpression += ' and ';
        _.each(opt, function (option, index) {
          if (index !== 0) filterExpression += ' or '; else filterExpression += '(';
          filterExpression += option.operand + ' ' + option.operator + ' ' + option.value;
          if (index === opt.length - 1) filterExpression += ')';
        });
      });
    }
    if ((filterText === '' || (adgroupOptions.controlMode === 'campaign' || currentScope === 'campaign')) && campaignId) resultUrl += 'Campaigns(' + campaignId + ')/' + urlEntity; else resultUrl += urlEntity;
    resultUrl += '?';
    resultUrl += '$expand=Campaign($select=Id,Name,CampaignType,CampaignSubType)';
    resultUrl += '&$select=Name,Id,Status,Medium,Language';
    var isDSAMixedModeCampaignEnabled = _.result(config.get('Permissions'), 'IsDSAMixedModeCampaignEnabled', false);
    if (isDSAMixedModeCampaignEnabled) {
      resultUrl += ',AdGroupType';
    }
    resultUrl += '&$top=' + adgroupOptions.take;
    resultUrl += '&$skip=' + adgroupOptions.skip;
    if (filterText !== '') {
      var $filter = odataQuery.convertToOData({
        Name: {
          $contains: encodeURIComponent(filterText)
        }
      }, {});
      resultUrl += '&$filter=' + $filter;
      if (filterExpression !== '') resultUrl += ' and ' + filterExpression;
    } else {
      if (filterExpression !== '') resultUrl += '&$filter=' + filterExpression;
    }
    resultUrl += '&$count=true';
    return resultUrl;
  }
});
export default collection;

